import router from '@/router/index'

export default {
  'timesheet.create': (item) => ({
    id: item.data.timesheet_id,
    href: router.resolve({ name: 'timesheet', params: { employeeId: item.data.employee_id, id: item.data.timesheet_id } }).href
  }),
  'timesheet.update': (item) => ({
    id: item.data.timesheet_id,
    href: router.resolve({ name: 'timesheet', params: { id: item.data.timesheet_id } }).href
  }),
  'timesheet.multiple_months_batch.success': (item) => ({
    id: item.data.employee_id,
    month: item.data.month,
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href
  }),
  'timesheet.multiple_users_batch.success': (item) => ({
    id: item.data.employee_id,
    month: item.data.month,
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href
  }),

  'employee.update': (item) => ({
    id: item.data.employee_id,
    href: router.resolve({ name: 'employee', params: { id: item.data.employee_id } }).href
  }),
  'employee.delete': (item) => ({
    id: item.data.employee_id,
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href
  }),
  'employee.create': (item) => ({
    id: item.data.employee_id,
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href
  }),
  'employee.assigned_as_manager': (item) => ({
    id: item.data.employee_id,
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href
  }),
  'employee_account.create': (item) => ({
    id: item.data.employee_id,
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href
  }),

  'timetracking.start': (item) => ({
    id: item.data.employee_id,
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href
  }),
  'timetracking.stop': (item) => ({
    id: item.data.employee_id,
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href
  }),

  'activity_period.create': (item) => ({
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href,
    period: item.data.period
  }),
  'activity_period.delete': (item) => ({
    href: router.resolve({ name: 'employee', params: { employeeId: item.data.employee_id } }).href,
    period: item.data.period
  }),

  'salaryGroup.create': (item) => ({
    id: item.data.salaryGroup_id
  }),
  'salaryGroup.delete': (item) => ({
    id: item.data.salaryGroup_id
  }),
  'salaryGroup.update': (item) => ({
    id: item.data.salaryGroup_id
  })
}
